module.exports = __webpack_public_path__ + "assets/img/pane3.bcb6139d.jpg";